import {IOrganization} from "../../interfaces/IOrganization";
import {Grid, Mui, MuiIcons, FormChips} from "@leap4/frontend";
import type {SelectChangeEvent} from "@mui/material/Select";
import React, {useState} from "react";
import {IOrganizationPartnersForeingAccess} from "./ForeingAccess.container";
import {IOSSwitch} from "../../../App/IOSSwitch";

const {Button, FormControlLabel, MenuItem, Select, TextField} = Mui;
const {Delete: DeleteIcon} = MuiIcons;


interface IPublisherLoginsAccessProps {
    organization: IOrganizationPartnersForeingAccess,
    isLoading: boolean,
    handleSkipChange: (forOrganizationId: string, skip: boolean) => void,
    availableOrganizations: Array<IOrganization>,
    onUpdateSelectedOrgs: (selectedOrg: string, currentOrgId: string | undefined) => void,
    onPartnersChange: (choosenPartners: string[], currentOrgId: string) => void,
    onOrganizationRemove: (selectedOrg: string | undefined) => void,
}

export const ForeingAccess = ({
                                    organization,
                                    isLoading,
                                    handleSkipChange,
                                    availableOrganizations,
                                    onUpdateSelectedOrgs,
                                    onPartnersChange,
                                    onOrganizationRemove,
                                }: IPublisherLoginsAccessProps) => {

    const {org, selectedPartners, optionalPartners, toSkipDiscrepancy, facadeName} = organization

    const [skip, setSkip] = useState<boolean>(toSkipDiscrepancy);
    const handleOrgChange = ({target}: SelectChangeEvent) => {
        const currentOrgId = org?._id
        onUpdateSelectedOrgs(target.value, currentOrgId)
    }
    const handlePartnersChange = (choosenPartners: string[]) => {
        onPartnersChange(choosenPartners, org._id)
    }
    const handleOrganizationRemove = () => {
        onOrganizationRemove(org._id)
    }

    const handleSkip = (event, checked: boolean) => {
        handleSkipChange(org._id, checked)
        setSkip(checked)
    }

    if (optionalPartners[0]) {
        const firstPartner = optionalPartners[0];
        if (typeof firstPartner === "string" || !firstPartner.id) return <></>;
    }
    return (
        <Grid container justifyContent={"space-between"} spacing={0.5} mb={2}>
            <Grid item xs={2}>

                <Select size={"small"} disabled={isLoading}
                        onChange={handleOrgChange}
                        value={org?._id || 'NULL'}
                        fullWidth
                >

                    <MenuItem disabled value={'NULL'}>
                        <em>Select Organization</em>
                    </MenuItem>

                    {availableOrganizations.map(o => {
                        return <MenuItem key={o._id} divider value={o?._id || 'ID'}>{o?.name}</MenuItem>
                    })}

                </Select>
            </Grid>
            <Grid item xs={2}>
                <TextField
                    size={'small'}
                    fullWidth
                    variant="outlined"
                    label={facadeName ? "Facade name" : "No facade name"}
                    type="string"
                    value={facadeName || ''}
                    disabled
                />
            </Grid>
                <Grid item xs={4.5}>
                <FormChips optionsList={optionalPartners}
                           onUpdateItems={handlePartnersChange}
                           inputName={optionalPartners?.length ? "Supply Partners" : "No Partners"}
                           enableCreate={false}
                           chips={selectedPartners}
                           pureCreate={false}
                           textFieldProps={{size: "small", style: {width: "100%"}}}
                           stackProps={{style: {width: "100%"}}}
                           labelKey={"name"}
                           valueKey={"id"}

                />
                </Grid>
                <Grid item xs={1.5}>
                    <FormControlLabel
                        control={<IOSSwitch sx={{ m: 1 }}/>}
                        onChange={handleSkip}
                        checked={skip}
                        disabled={!org?._id}
                        label="To skip discrepancy"
                    />
                </Grid>

                <Grid item xs={1.5}>
                    <Button fullWidth variant="outlined" disabled={!org?._id} startIcon={<DeleteIcon/>}
                            onClick={handleOrganizationRemove}>
                        Delete
                    </Button>
                </Grid>
        </Grid>
    )
}
